import { Dialog } from '../ui/Dialog';
import { Button } from '../ui/Button';
import { useLanguageStore } from '../../stores/language-store';
import { t } from '../../i18n/translations';
import { useState } from 'react';

interface SaveVersionDialogProps {
  open: boolean;
  onClose: () => void;
  onOverwrite: (comment: string) => void;
  onNew: (comment: string) => void;
}

export function SaveVersionDialog({ open, onClose, onOverwrite, onNew }: SaveVersionDialogProps) {
  const language = useLanguageStore((s) => s.language);
  const [comment, setComment] = useState('');

  return (
    <Dialog open={open} onClose={onClose} title={t(language, 'save')}>
      <div className="space-y-5">
        <p className="text-sm text-text">{t(language, 'saveVersionPrompt')}</p>
        <div className="space-y-2">
          <label className="text-xs font-semibold text-text-muted">{t(language, 'versionComment')}</label>
          <textarea
            value={comment}
            onChange={(e) => setComment(e.target.value)}
            placeholder={t(language, 'versionCommentPlaceholder')}
            rows={3}
            className="w-full px-2 py-2 bg-surface border border-surface-lighter rounded text-xs text-text placeholder:text-text-muted focus:outline-none focus:border-accent resize-none"
          />
        </div>
        <div className="flex justify-end gap-2">
          <Button variant="secondary" onClick={() => onOverwrite(comment)}>
            {t(language, 'overwrite')}
          </Button>
          <Button onClick={() => onNew(comment)}>{t(language, 'newVersion')}</Button>
        </div>
      </div>
    </Dialog>
  );
}
